import React from "react";

interface UserDetailsShimmerProps {
  orgLayout?: "grid" | "list";
  orgCount?: number;
}

const UserDetailsShimmer: React.FC<UserDetailsShimmerProps> = ({
  orgLayout = "grid",
  orgCount = 8,
}) => {
  return (
    <>
      {/* Organizations section header shimmer */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-4 w-32 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse" />
          <div className="h-[18px] w-16 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-sm animate-pulse" />
        </div>
        <div className="flex items-center p-0.5 border border-border-gray dark:border-border-gray-dk rounded-sm">
          <div className="w-[20px] h-[20px] bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-sm animate-pulse" />
          <div className="w-[20px] h-[20px] bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-sm animate-pulse" />
        </div>
      </div>

      {/* Search input shimmer */}
      <div className="w-[264px] h-[30px] bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-md animate-pulse mt-2" />

      {/* Organizations grid/list shimmer */}
      <div
        className={`grid gap-2 overflow-y-auto max-h-[calc(100vh-570px)] mt-3.5 ${
          orgLayout === "grid" ? "grid-cols-2" : "grid-cols-1"
        }`}
      >
        {Array.from({ length: orgCount }).map((_, index) => (
          <div
            key={`org-shimmer-${index}`}
            className="p-2 flex items-center justify-between rounded-lg border border-border-gray dark:border-border-gray-dk"
          >
            <div className="flex items-center gap-1">
              <div className="w-[18px] h-[18px] bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse" />
              <div className="h-4 w-20 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse" />
            </div>
            <div className="w-[12px] h-[12px] bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse" />
          </div>
        ))}
      </div>
    </>
  );
};

export default UserDetailsShimmer;
